module.exports = __webpack_public_path__ + "img/alternative-contents-empty-list-light.eca5e9ce.svg";